import { useEffect, useState } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";

import { Box, Divider, Stack } from "@mui/material";
import { SimpleLabel } from "../../components/Label/SimpleLabel";
import ItemInput from "../../components/Input/ItemInput";
import ActionModal, {
  ConfirmActionModal,
} from "../../components/Modals/ActionModal";

import { CreateUsersTy, PageActions } from "../../config/types";
import {
  dmsDomainsNamesTy,
} from "../../config/constants/domain";
import { Field, FormField } from "../../utils/formSchema";
import { isFormFilled } from "../../utils/validators";

import { UserApi } from "../../services/users";
import useQueryParam from "../../hooks/useQueryParam";
import { usePageModels } from "../../hooks/usePageActions";
import { DamsAppAsset } from "../../assets/registry";
import { UserCategorySelectInput } from "../../common-ui/select-input-models/UserCategorySelectInput";
import { DomainSelectInput } from "../../common-ui/select-input-models/DomainSelectInput";
import { FormSchemaType, useDmsForm } from "../../hooks/useDmsFrom";
import { UserRoleSelectInput } from "../../common-ui/select-input-models/UserRoleSelectInput";
import appRoutePath from "../../config/path";
import useAppNavigation from "../../hooks/useAppNavigation";
import LocalStorageService from "../../store/localStorage";
import { alertDialogStore } from "../../store/dialogs";

interface UserFormTy extends FormField<CreateUsersTy> {
  submitAttempt?: boolean;
}
const getDefaultValue = (value: string) => ({
  isValid: true,
  value,
  errorMessage: "",
});
const INITAIL_VALUE:CreateUsersTy={
  email: '',
  first_name: '',
  last_name: '',
  telephone:'',
  role_id: '',
  user_domain: '',
  domain_id:'',
  user_category_id: '',
};

function AddUsersPage() {

  const {form,updateForm,updateInputField,fieldHasError,onFormSubmit}=useDmsForm(INITAIL_VALUE)
  // alert messages


  const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);
  const [pageAction, updatePageAction] = useState<PageActions>();
  const [userRoleName, setUserRoleName]=useState<string>('');
  const { models, closeModel, openModel } = usePageModels();
  const [isProcessing, setProcess] = useState(false);

  const getId = useQueryParam("id");

  const navigate = useAppNavigation();
  useEffect(() => {
    const fetchData = async () => {
      if (getId) {
        const userRequest = await UserApi.getUserById(getId);
        if (userRequest.data) {
          const data = userRequest.data;
          
          updateForm({
            email: getDefaultValue(data.email),
            first_name: getDefaultValue(data.first_name),
            last_name: getDefaultValue(data.last_name),
            telephone: getDefaultValue(data.telephone),
            domain_id: getDefaultValue(data.domain_location),
            role_id: getDefaultValue(data.role),
            user_category_id: getDefaultValue(data.user_category_id),
            user_domain: getDefaultValue(data.user_domain),
          });
        }
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getId]);


  function onSaveItemClick() {
    updateForm((prev) => ({ ...prev, submitAttempt: true }));
    const formValid = isFormFilled<UserFormTy>(form);
    if (formValid) {
      updatePageAction({
        type: "add",
        title: getId ? "Update User" : "Add User",
      });
      openModel("add");
    }
  }



  function handleToDomainSelect(item: Field, domain: dmsDomainsNamesTy) {
    updateForm((p) => ({
      ...p,
      domain_id: item,
      user_domain: { value: domain, isValid: true },
    }));
  }
  function handleUserRoleOnchange(item: Field,roleName?: string) {
    updateForm((p) => ({
      ...p,
      role_id: item,
    }));
    setUserRoleName(roleName??'')
  }
  function handleCategorySelect(item: Field) {
    updateForm((p) => ({ ...p, user_category_id: item }));
  }

  function onSeeAllPress() {
    navigate({path:appRoutePath.USERS_PAGE,isSibling:true})
  }

  function onAddNewPress() {
    closeModel();
  }


    useEffect(() => {
      const prevFormState =
        LocalStorageService.get<FormSchemaType<CreateUsersTy>>("ADD_USER_FORM");
      if (prevFormState) {
        updateForm(prevFormState);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    function cancelAddItem() {
      setUnsavedChanges(true);
    }
    function saveChanges() {
          LocalStorageService.save("ADD_USER_FORM", form);
          setUnsavedChanges(false);
          alertDialogStore.open({
            title: "Save your changes",
            subtitle: "current changes saved on device",
            onLeftBtnPress: () => {},
            onRightBtnPress: onSeeAllPress,
            isSuccess: false,
            rightBtnTxt: "Continue",
            leftBtnTxt: "Close",
          });
    }
    function discardChanges() {
      LocalStorageService.remove("ADD_USER_FORM");
      setUnsavedChanges(false);
      onSeeAllPress()
    }
  
    async function confirmUserSave() {
      const {data,isValid}=onFormSubmit()
    
      if (!isValid) return;
   
      try {
        setProcess(true);
        const request = getId
          ? UserApi.updateUser(getId, data)
          : UserApi.createUser(data);
        const response = await request;
        LocalStorageService.remove("ADD_USER_FORM");
        updatePageAction((p) => ({
          ...p,
          success: response.success,
          message: response.message,
          title: response.success
            ? getId
              ? "User Updated"
              : "User Added"
            : getId
            ? "User Update Failed"
            : "Add User Failed",
        }));
        openModel("alert");
      } catch (error) {
        closeModel();
      }
      setProcess(false);
      discardChanges()
    }
  let modalTitle = getId ? "Confirm User Update" : "Confirm User Addition";
  let modelSubtitle = getId
    ? `click confirm to update ${form.email.value} `
    : `You are adding ${form.email.value} ${userRoleName? 'as '+userRoleName:'' }. Click "Confirm" to Add`;
  return (
    <MainPageBase
      pageState={"add-item"}
      title={getId ? " Update User" : "Add New User"}
      cancelBtnClick={cancelAddItem}
      addItemBtnOnClick={onSaveItemClick}
    >
      <Box
        height={`100%`}
        display={"flex"}
        // alignItems={'center'}
        justifyContent={"center"}
      >
        <Stack
          // width={'100%'}
          m={"0px 32px"}
          gap={5}
        >
          {/* personal information  */}
          <Stack direction={"row"} gap={4}>
            <SimpleLabel title="Personal Information" />

            <Box display={"flex"} gap={4} pb={3} pr={3}>
              <Stack gap={3}>
                <ItemInput
                  label="First Name"
                  placeholder="Enter Name"
                  handleChange={updateInputField("first_name")}
                  value={form.first_name.value}
                  error={fieldHasError("first_name")}
                  errorMessage={form.first_name.errorMessage}
                />
                <ItemInput
                  label="Email"
                  placeholder="example@gmail.com"
                  handleChange={updateInputField("email", "email")}
                  value={form.email.value}
                  error={fieldHasError("email")}
                  errorMessage={form.email.errorMessage}
                />
              </Stack>

              <Stack gap={3}>
                <ItemInput
                  label="Last Name"
                  placeholder="Enter Name"
                  handleChange={updateInputField("last_name")}
                  value={form.last_name.value}
                  error={fieldHasError("last_name")}
                  errorMessage={form.last_name.errorMessage}
                />
                <ItemInput
                  label="Phone Number"
                  placeholder="eg.(233)25764112"
                  handleChange={updateInputField("telephone", "telephone")}
                  value={form.telephone.value}
                  error={fieldHasError("telephone")}
                  errorMessage={form.telephone.errorMessage}
                />
              </Stack>
            </Box>
          </Stack>

          <Divider variant="fullWidth" />

          {/* role information  */}
          <Stack direction={"row"} gap={4} p={"24px 0px"}>
            <SimpleLabel title="Role Information" />

            <Box display={"flex"} gap={4}>
              <Stack gap={3} width={270}>
                <DomainSelectInput
                  label="User Domain"
                  placeholder="Select user domain"
                  error={fieldHasError("user_domain")}
                  submitAttempt={form.submitAttempt===true}
                  handleChange={handleToDomainSelect}
                  value={{
                    domain_name: form.user_domain.value ?? undefined,
                    domain_id: form.domain_id.value ?? undefined,
                  }}
                />
              </Stack>

              <Stack gap={2.2}>
                <UserCategorySelectInput
                  label="User Category"
                  placeholder="Select User Category"
                  handleChange={handleCategorySelect}
                  value={form.user_category_id.value}
                  error={!form.user_category_id.isValid && form.submitAttempt}
                />
                <UserRoleSelectInput
                  placeholder="Select User Role"
                  handleChange={handleUserRoleOnchange}
                  label="User Role"
                  error={fieldHasError("role_id")}
                  value={form.role_id.value}
                  errorMessage={form.role_id.errorMessage}
                 />
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Box>

      {/* modals  */}

      {/* succesfully saved user  */}
      <ActionModal
        show={models.showAlertModel}
        title={pageAction?.title ?? ""}
        leftIcon={!pageAction?.success ? DamsAppAsset.icons.warning : undefined}
        subtitle={pageAction?.message ?? ""}
        onLeftBtnPress={onSeeAllPress}
        leftBtnTxt={"See All"}
        onRightBtnPress={onAddNewPress}
        rightBtnTxt={pageAction?.success ? "Add New" : "retry"}
        onClosePress={closeModel}
      />

      {/* confirm user save */}
      <ConfirmActionModal
        show={models.showAddModel}
        // title={"Add User"}
        title={modalTitle}
        subtitle={modelSubtitle}
        onRightBtnPress={confirmUserSave}
        onRightBtnLoading={isProcessing}
        rightBtnTxt={"Confirm"}
        onLeftBtnPress={closeModel}
        leftBtnTxt={"Cancel"}
        onClosePress={closeModel}
      />

      {/* confirm unsaved changes */}
      <ConfirmActionModal
        show={unsavedChanges}
        title={"Unsaved Changes"}
        subtitle={`Do you want to save changes or discard?`}
        onRightBtnPress={() => saveChanges()}
        rightBtnTxt={"Save Changes"}
        onLeftBtnPress={() => discardChanges()}
        leftBtnTxt={"Discard"}
        onClosePress={() => setUnsavedChanges(false)}
      />
    </MainPageBase>
  );
}

export { AddUsersPage };
